/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

export const getData = state => state.form
export const isDataSendingToServer = state => state.formUtil.isSendingInProgress
